import React from "react"
import PropTypes from "prop-types"

const Logo = ({ width, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 100"
    width={width}
  >
    <path
      fill="#ba2334"
      d="M314.35 58.48h-7.13v-7.35h7.13zm0 28.1h-7.13v-7.35h7.13z"
    />

    <path
      fill="#5e514e"
      d="M159.47 67.94c0 11-8.06 19.51-18.57 19.51-10.3 0-18.65-8.36-18.65-19.51s8.28-19.37 18.5-19.37a16.32 16.32 0 0 1 12.82 6.26V33h5.9zM140.9 54.18c-6.91 0-12.53 6-12.53 13.76S134 81.83 140.9 81.83s12.53-6.19 12.53-13.89-5.69-13.76-12.53-13.76zM202.75 86.58h-5.91v-5.76a15.79 15.79 0 0 1-12.84 6.7c-10.23 0-18.51-8.35-18.51-19.44s8.35-19.51 18.65-19.51c10.51 0 18.58 8.57 18.58 19.51zm-18.58-32.4c-6.91 0-12.53 6.12-12.53 13.9s5.62 13.75 12.53 13.75 12.53-6.12 12.53-13.75-5.76-13.9-12.53-13.9zM206.06 49.5h6.48l10.22 29h.07l10.22-29h6.49l-13.47 37.08h-6.55zM245.58 43.89v-4.61a3.06 3.06 0 0 1 6.12 0v4.61zm6.12 42.69h-6.12V49.5h6.12zM296.77 67.94c0 11-8.06 19.51-18.57 19.51-10.3 0-18.65-8.36-18.65-19.51s8.28-19.37 18.5-19.37a16.32 16.32 0 0 1 12.82 6.26V33h5.9zM278.2 54.18c-6.91 0-12.53 6-12.53 13.76s5.62 13.89 12.53 13.89 12.53-6.19 12.53-13.89S285 54.18 278.2 54.18zM343.28 87.45c-10.51 0-18.64-8.5-18.64-19.51V33h5.9v21.83a16.43 16.43 0 0 1 12.82-6.26c10.29 0 18.5 8.28 18.5 19.37s-8.35 19.51-18.58 19.51zm0-33.27c-6.84 0-12.52 6.12-12.52 13.76s5.76 13.89 12.52 13.89 12.46-6 12.46-13.89-5.61-13.76-12.46-13.76zM386.84 48.78v5.69c-7.12-.65-11.66 2.81-11.66 9.94v22.17h-6.05v-22c0-11.26 8-16.95 17.71-15.8zM418.09 49.5h6.12V72c0 9.36-6.77 15.48-15.48 15.48S393.25 81.33 393.25 72V49.5h6.05V72c0 5.54 3.67 9.57 9.43 9.57s9.36-4 9.36-9.57zM439.19 86.58h-6.05V64.05c0-9.36 6.62-15.48 15.48-15.48S464 54.69 464 64.05v22.53h-6V63.83c0-5.54-3.68-9.58-9.36-9.58s-9.43 4-9.43 9.58zM507.94 75.06c-2.88 7.92-9.07 12.39-17.64 12.39a19 19 0 0 1-19-19.37c0-10.73 8.36-19.51 18.65-19.51 8.07 0 15.91 5.61 18.07 15.26l-28.43 12a12.64 12.64 0 0 0 10.72 5.83 12 12 0 0 0 11.31-6.62zm-30.31-4.53l22.9-9.65a12.53 12.53 0 0 0-10.59-6.55c-5.9 0-12.53 5.18-12.53 13.68a14.16 14.16 0 0 0 .22 2.52zM515 33h6v39.83c0 6.55 4 8.21 8.63 8v5.76C521 87.59 515 82.48 515 73.05zM534.29 33h6v39.83c0 6.55 4 8.21 8.64 8v5.76c-8.71 1-14.68-4.1-14.68-13.53zM588.51 75.06c-2.88 7.92-9.07 12.39-17.64 12.39a19 19 0 0 1-19-19.37c0-10.73 8.35-19.51 18.65-19.51 8.06 0 15.91 5.61 18.07 15.26l-28.44 12a12.65 12.65 0 0 0 10.73 5.83 12 12 0 0 0 11.3-6.62zm-30.31-4.53l22.89-9.65a12.52 12.52 0 0 0-10.58-6.55C564.6 54.33 558 59.51 558 68a13.28 13.28 0 0 0 .2 2.53z"
    />

    <path
      fill="#ba2334"
      d="M87.55 12.48H64.11v20.18h11.8v-8.37h11.64a9.67 9.67 0 0 1 0 19.34H64.1v11.81h23.45a9.67 9.67 0 0 1 0 19.34H75.91V66.1h-11.8v20.48h23.44a21.45 21.45 0 0 0 14.75-37 21.46 21.46 0 0 0-14.75-37.1zM34.73 12.48H11.42v31.15H23.3V24.36h11.43a9.73 9.73 0 0 1 9.72 9.72V65a9.73 9.73 0 0 1-9.72 9.72H23.3V55.44H11.42v31.14h23.31A21.6 21.6 0 0 0 56.33 65V34.08a21.6 21.6 0 0 0-21.6-21.6z"
    />
  </svg>
)
/* eslint-enable max-len */

Logo.propTypes = {
  width: PropTypes.string.isRequired,
}

Logo.defaultProps = {
  width: "315px",
}

Logo.displayName = "Logo"

export default Logo
